import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';
import { avatarService } from '@/services/avatar';
import useVuelidate from '@vuelidate/core';
import { minValue, required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useAvatarCategoryEdit() {
    const route = useRoute();
    const router = useAppRouter();
    const { executeAction, excuteAndNotify, confirmAndRemove } = useCrudActions();

    const model = reactive({
        id: route.params.categoryId,
        parentId: null,
        parentName: null,
        name: '',
        totalItem: null,
        position: 0,
        gender: 0,
        posX: 0,
        posY: 0,
        image: null,
        imageStatus: null,
        imageFile: null,
        isPublished: false,
        isRequired: false,
        isBody: false,
        canDelete: false
    });

    const validations = {
        name: { required },
        gender: { required },
        position: { required, min: minValue(0) },
        isPublished: { required },
        isRequired: { required },
        isBody: { required },
        imageFile: {}
    };

    const v$ = useVuelidate(validations, model);

    const loadParentName = executeAction({
        request: avatarService.category.get,
        onSuccess: ({ data }) => (model.parentName = data.name),
        onError: () => router.push({ name: ROUTE_NAME_AVATAR.CATEGORY.INDEX })
    });

    const actions = {
        fetch: executeAction({
            request: () => avatarService.category.get(model.id),
            onSuccess: ({ data }) => Object.assign(model, data),
            onError: () => router.push({ name: ROUTE_NAME_AVATAR.CATEGORY.INDEX }),
            onFinally: async () => {
                if (model.parentId > 0) {
                    await loadParentName(model.parentId);
                } else {
                    model.parentId = null;
                }
            }
        }),

        update: excuteAndNotify({
            validator: v$,
            request: () =>
                avatarService.category.update(
                    model.id,
                    model.name,
                    model.position,
                    model.gender,
                    model.isPublished,
                    model.isRequired,
                    model.posX,
                    model.posY,
                    model.isBody,
                    model.imageFile
                ),
            onSuccess: () =>
                router.push({ name: ROUTE_NAME_AVATAR.CATEGORY.INDEX, query: { parentId: model.parentId, name: '' } })
        }),

        remove: confirmAndRemove({
            request: () => avatarService.category.remove(model.id),
            onSuccess: () =>
                router.push({ name: ROUTE_NAME_AVATAR.CATEGORY.INDEX, query: { parentId: model.parentId, name: '' } })
        })
    };

    return { model, v$, actions };
}
